// assets
import {
  IconDashboard,
  IconSitemap,
  IconArticle,
  IconCoin,
  IconAdjustments,
  IconKey,
  IconGardenCart,
  IconUser,
  IconUserScan,
  IconSearch,
  IconFolders,
  IconFiles,
  IconCoins,
  IconQrcode,
  IconCreditCard,
  IconTicket,
  IconPackage,
  IconCalendarRepeat,
  IconReceipt,
  IconMessageCircle,
  IconVideo,
  IconDeviceLaptop,
  IconHistory,
  IconServer,
  IconWorld,
} from '@tabler/icons-react';

// constant
const icons = {IconCoins,IconFiles, IconFolders, IconSearch, IconDashboard, IconSitemap, IconArticle, IconCoin, IconAdjustments, IconKey, IconGardenCart, IconUser, IconUserScan,IconQrcode,IconCreditCard,IconTicket,IconPackage,IconCalendarRepeat,IconReceipt,IconMessageCircle,IconHistory,IconVideo,IconDeviceLaptop,IconServer,IconWorld };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const panel = {
  id: 'panel',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: '总览',
      type: 'item',
      url: '/panel/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'searchpage',
      title: '搜索',
      type: 'item',
      url: '/panel/search',
      icon: icons.IconSearch,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'taskpage',
      title: '项目',
      type: 'item',
      url: '/panel/task',
      icon: icons.IconFolders,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'filepage',
      title: '文件',
      type: 'item',
      url: '/panel/file',
      icon: icons.IconFiles,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'sms',
      title: '短信',
      type: 'item',
      url: '/panel/sms',
      icon: icons.IconMessageCircle,
      breadcrumbs: false
    },
    {
      id: 'sms-history',
      title: '信管',
      type: 'item',
      url: '/panel/sms-history',
      icon: icons.IconArticle,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'channel',
      title: '渠道',
      type: 'item',
      url: '/panel/channel',
      icon: icons.IconSitemap,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'node',
      title: '节点',
      type: 'item',
      url: '/panel/node',
      icon: icons.IconServer,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'ddns',
      title: '动态DNS',
      type: 'item',
      url: '/panel/ddns',
      icon: icons.IconWorld,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'log',
      title: '日志',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconArticle,
      breadcrumbs: false
    },

    {
      id: 'quota',
      title: '套餐',
      type: 'item',
      url: '/panel/quota',
      icon: icons.IconCalendarRepeat,
      breadcrumbs: false
    },
    {
      id: 'topup',
      title: '充值',
      type: 'item',
      url: '/panel/topup',
      icon: icons.IconCreditCard,
      breadcrumbs: false
    },
    {
      id: 'manage',
      title: '管理',
      type: 'item',
      url: '/panel/manage',
      icon: icons.IconUser,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'download-management',
      title: '下载',
      type: 'item',
      url: '/panel/download',
      icon: icons.IconPackage,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'profile',
      title: '我的',
      type: 'item',
      url: '/panel/profile',
      icon: icons.IconUserScan,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'setting',
      title: '设置',
      type: 'item',
      url: '/panel/setting',
      icon: icons.IconAdjustments,
      breadcrumbs: false,
      isAdmin: true
    }
  ]
};

export default panel;
